import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import isString from 'lodash/isString';
import Styled from './styles';

export interface AppBannerNameProps {
  /** Product Name */
  children: string | React.ReactNode;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

export interface ThemeShape {
  APP_BANNER: Record<string, unknown>
}

/** AppBannerName component, displays product name and description (see `secondary` prop). */
const AppBannerName = React.forwardRef<HTMLElement, AppBannerNameProps>((props: AppBannerNameProps, ref) =>
  getContext(({ RTL, theme }: { theme?: ThemeShape, RTL: boolean }) => {
    const {
      children,
      theme: propTheme,
      ...otherProps
    } = props;
    const resolvedTheme = _merge({}, theme.APP_BANNER, propTheme);
    return isString(children) ? (
      <Styled.AppBannerName
        $rtl={RTL}
        ref={ref}
        $theme={resolvedTheme}
        {...otherProps}
      >
        {children}
      </Styled.AppBannerName>
    ) : children;
  }));

AppBannerName.defaultProps = {
  theme: {}
};

AppBannerName.displayName = 'AppBannerName';

export default AppBannerName;
